import Vue from 'vue'
// import VueMeta from 'vue-meta'
import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import moment from 'moment'
import VueI18n from 'vue-i18n'

Vue.prototype.moment = moment
import App from './App.vue'
import Store from "./store/index.js"
import Utils from "./components.utils.js"
import languageMapperMixin from "./mixins/lanaguageMapperMixin.js"
import ComponentRegistrator from "./components.registrator.js"
import vuetify from "./plugins/vuetify.js"
import router from "./routes/index.js"
import VueTour from 'vue-tour'
import dateTimeMixins from "./mixins/dateFormatMixin.js"
// import "../src/assets/common.scss";
import convertProxyIPdomainNameTransformer from './mixins/convertProxyPathToLoggedInDomainIP.js';

import exportDamcomponentsToPlugins from './export-components-for-plugins.js';

// import "./global/global.css";
import "./global/themes/suneditor/suneditor_theme.css"

require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)
Vue.use(VueI18n)


Vue.config.productionTip = false

const i18n = new VueI18n({
    locale: 'en',
    messages: {
    }
  })
  
Vue.prototype.$t = function(key) {
const currentLocale = this.$i18n.locale;
const localeMessages = this.$i18n.messages[currentLocale];
const caseInsensitiveKey = Object.keys(localeMessages).find(k => k.toLowerCase() === key.toLowerCase());
return localeMessages[caseInsensitiveKey] || key;
};


export default i18n;    

Vue.mixin(dateTimeMixins); 
Vue.mixin(languageMapperMixin);
Vue.mixin(convertProxyIPdomainNameTransformer);

const app = new Vue({
    render: h => h(App),
    store: Store,
    vuetify,
    router,
    i18n,
    mixins:[dateTimeMixins, languageMapperMixin , convertProxyIPdomainNameTransformer],
    mounted(){

       try{
          document.body["component"] = exportDamcomponentsToPlugins;  // expose damweb components to plugins
       }catch(e){console.log(e)}

        /**
         *    Fix for 1) Cannot read properties of undefined (reading 'cloneNode')
         *            2) TypeError: Cannot convert undefined or null to object
         *            3) TypeError: d.elm.getBoundingClientRect is not a function
         *            4) TypeError: t.getAttribute is not a function 
         *
         */

        try{
           const warning = this.$toast.warning;
        //    const info = this.$toast.info;
           const success = this.$toast.success;
           const error = this.$toast.error;
            
            this.$toast.warning = function(message){
                if(!message) return;
                return warning(message);
            }

            this.$toast.success = function(message){
                if(!message) return;
                return success(message);
            }

            this.$toast.success = function(message){
                if(!message) return;
                return success(message);
            }

            this.$toast.error = function(message){
                if(!message) return;
                return error(message);
            }
            
        }catch(e){console.log(e)}

    },  
})


ComponentRegistrator(Vue)
// Vue.use(VueMeta, { refreshOnceOnNavigation: false })
Vue.use(Toast, Utils.getToastNotificationOptions());
if(!localStorage.getItem("userInfo") && Utils.getCookieValue("userId")){
    let payload = {params:{userId: Utils.getCookieValue("userId"),effective_access_control:true,effective_permissions:true}}
    Store.dispatch("users/getUserInfoFromServer", payload,{root:true}).then((data)=>{
        console.log("Loading app of user GET.",('user' in data))
        app.$mount('#app')
    }).catch((e)=>{
        console.log("Error while loading user info from API on mount.",e)
        app.$mount('#app')
    })

}else{
    app.$mount('#app')
}

Vue.directive('click-outside', {
    bind: function(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
            // here I check that click was outside the el and his children
            if (!(el == event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    },
});